export default "__VITE_ASSET__zPnmmmby__"